import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID, COLLECTION } from '@/plugins/sdk/fields'
import Index from '@/plugins/sdk/resources/RateCard/Index'
import RateCard from '@/plugins/sdk/resources/RateCard'

export default class extends Resource {
  static name = 'ratecard_group'

  static get fields () {
    return {
      id: new UUID(),
      is_busy: new BOOLEAN(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      indices: new COLLECTION(Index),
      rate_cards: new COLLECTION(RateCard)
    }
  }
}
